<div class="close-case-dialog">
  <div class="dialog-header">
    <mat-icon [class.concluida]="data.targetStatus === 'CONCLUIDA'"
              [class.desestimada]="data.targetStatus === 'DESESTIMADA'">
      {{ data.targetStatus === 'CONCLUIDA' ? 'task_alt' : 'cancel' }}
    </mat-icon>
    <div>
      <h3>{{ data.targetStatus === 'CONCLUIDA' ? 'Concluir caso' : 'Desestimar caso' }}</h3>
      <p class="subtitle">
        El estado cambiará a <strong>{{ data.statusLabel }}</strong>. Después de esto,
        el caso quedará cerrado y ya no se podrán enviar más mensajes.
      </p>
    </div>
  </div>

  <div class="dialog-body">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Mensaje final para el denunciante *</mat-label>
      <textarea matInput [(ngModel)]="finalMessage" rows="5" maxlength="5000"
                placeholder="Explica brevemente las conclusiones de la investigación, medidas tomadas, etc."></textarea>
      <mat-hint align="end">{{ finalMessage.length }} / 5000</mat-hint>
    </mat-form-field>

    <div class="field-label">Adjuntos (opcional)</div>
    <app-admin-file-uploader [maxFiles]="4" (filesChanged)="onFilesChanged($event)"></app-admin-file-uploader>

    <mat-form-field appearance="outline" class="w-full notes-field">
      <mat-label>Notas internas (opcional)</mat-label>
      <input matInput [(ngModel)]="notes" maxlength="500" placeholder="Quedan guardadas en el historial, no las ve el denunciante">
    </mat-form-field>
  </div>

  <div class="dialog-actions">
    <button mat-stroked-button (click)="cancel()">Cancelar</button>
    <button mat-flat-button
            [color]="data.targetStatus === 'CONCLUIDA' ? 'primary' : 'warn'"
            [disabled]="!finalMessage.trim()"
            (click)="confirm()">
      {{ data.targetStatus === 'CONCLUIDA' ? 'Concluir' : 'Desestimar' }} y cerrar caso
    </button>
  </div>
</div>
